import React from "react";

import { interfaces } from "@reactivated";

import { Template as CustomerServiceInfoBlock } from "../../templates/CustomerServiceInfoBlockTemplate";

/**
 * Renders the login / registration / password-reset pages' customer-service
 * block from the shared auth documents' opaque ``cs_info_json`` seam (a
 * serialized ``AuthCustomerServiceBlockInterface``). tempurpedic's block
 * diverges from the shared typed ``cs_info`` shape, so it travels as JSON and is
 * parsed here into the ``CustomerServiceInfoBlockTemplate`` island -- rendering
 * it as a real React child (not injected HTML) keeps its ChatLink an
 * interactive hydration island.
 *
 * Returns null on an empty or unparseable payload so a parse failure degrades
 * only this block, never the whole document.
 */
export const AuthCustomerServiceBlock = ({
    payload,
}: {
    payload: string;
}): React.JSX.Element | null => {
    if (!payload) {
        return null;
    }
    let parsed: interfaces.AuthCustomerServiceBlockInterface;
    try {
        parsed = JSON.parse(
            payload,
        ) as interfaces.AuthCustomerServiceBlockInterface;
    } catch {
        return null;
    }
    return <CustomerServiceInfoBlock {...parsed.cs_block} />;
};
